// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"styles_deleteButton__1VTdN"};